import { Controller } from '@hotwired/stimulus';
import i18n from '../init/i18n';

export default class extends Controller {
  static targets = ['button', 'description'];

  toggle() {
    const isExpanded = this.descriptionTarget.classList.toggle('h-21');
    if (isExpanded) {
      this.buttonTarget.textContent = i18n.t("sidebar.show_more");
    } else {
      this.buttonTarget.textContent = i18n.t("sidebar.show_less");
    }
  }
}
